import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { ChartModule } from '@ddt-web/chart';
import { SharedModule } from '@ddt-web/common';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';
import { DomModule } from '@ddt-web/dom';
import { CtaLinkModule } from '@ddt-web/elements';
import { GenericDirectivesModule, GenericPipesModule } from '@ddt-web/generic-utils';
import { SecuritiesTableModule } from '@ddt-web/securities-table';
import { CombinedDataTableModule } from '@ddt-web/table';

import { EsgCarbonEmissionsImpactComponent } from './esg-carbon-emissions-impact/esg-carbon-emissions-impact.component';
import { EsgCoverageComponent } from './esg-coverage/esg-coverage.component';
import { EsgHoldingRankingsComponent } from './esg-holding-rankings';
import { EsgHoldingRankingsPortfolioDataComponent } from './esg-holding-rankings/esg-holding-rankings-portfolio-data/esg-holding-rankings-portfolio-data.component';
import { EsgHoldingRankingsTableComponent } from './esg-holding-rankings/esg-holding-rankings-table/esg-holding-rankings-table.component';
import { EsgHoldingsTableComponent } from './esg-holdings-table/esg-holdings-table.component';
import { EsgIndustryInvolvementComponent } from './esg-industry-involvement/esg-industry-involvement.component';
import { EsgMetricsComponent } from './esg-metrics';
import { EsgRatingDistributionComponent } from './esg-rating-distribution';
import { EsgNoRatingHoldingsComponent } from './esg-rating-distribution/esg-no-rating-holdings/esg-no-rating-holdings.component';
import { EsgScoreDistributionComponent } from './esg-score-distribution/esg-score-distribution.component';
import { EsgScoreImpactComponent } from './esg-score-impact/esg-score-impact.component';

@NgModule({
	imports: [
		CommonModule,
		ChartModule,
		GenericPipesModule,
		SharedModule,
		CoreModule,
		DataServiceModule,
		CwpNgFrameworkModule,
		DisclosureModule,
		CombinedDataTableModule,
		SecuritiesTableModule,
		CtaLinkModule,
		GenericDirectivesModule,
		DomModule
	],
	declarations: [
		EsgMetricsComponent,
		EsgRatingDistributionComponent,
		EsgNoRatingHoldingsComponent,
		EsgScoreImpactComponent,
		EsgHoldingRankingsComponent,
		EsgCarbonEmissionsImpactComponent,
		EsgIndustryInvolvementComponent,
		EsgCoverageComponent,
		EsgHoldingsTableComponent,
		EsgScoreDistributionComponent,
		EsgHoldingRankingsPortfolioDataComponent,
		EsgHoldingRankingsTableComponent
	],
	exports: [
		EsgMetricsComponent,
		EsgRatingDistributionComponent,
		EsgScoreDistributionComponent,
		EsgScoreImpactComponent,
		EsgCoverageComponent,
		EsgIndustryInvolvementComponent,
		EsgHoldingsTableComponent,
		EsgHoldingRankingsComponent,
		EsgCarbonEmissionsImpactComponent
	]
})
export class EsgModule { }
